import React, {useState} from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {Input, message} from 'antd'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import './index.scss'

export const setBrokerBriefMutation = gql`
  mutation SetBrokerInstructionsForPhotographer($input: SetBrokerInstructionsForPhotographerInput!) {
    SetBrokerInstructionsForPhotographer(input: $input) {
      viewer {
        id
      }
    }
  }
`

const PhotographerBrief = ({currentBrief}) => {
  const [brief, setBrief] = useState(currentBrief)

  const updateBrief = (evt) => setBrief(evt.target.value)

  const saveBrief = (mutation) => {
    return mutation({
      variables: {
        input: {
          message: brief,
        },
      }
    })
    .then(() => {
      message.success('Din beskjed til fotograf er lagret')
    })
    .catch(() => {
      message.error('En feil oppstod med å endre melding til fotograf. Vennligst forsøk på nytt eller kontakt EFKT kundeservice.')
    })
  }

  const keyDown = (mutation, evt) => {
    const keyCode = evt.nativeEvent.code
    if (keyCode === 'Enter') {
      saveBrief(mutation)
    }
  }

  return (
    <Mutation mutation={setBrokerBriefMutation}>
      {(addExecutiveOfficer) => {
        return (
          <div className="photographer-brief">
            <Heading level={3}>Din beskjed</Heading>
            <Input
              value={brief}
              onChange={updateBrief}
              onKeyDown={keyDown.bind(null, addExecutiveOfficer)}
            />
            <Button
              type="action"
              onClick={saveBrief.bind(null, addExecutiveOfficer)}
            >
              Lagre
            </Button>
          </div>
        )
      }}
    </Mutation>
  )
}

PhotographerBrief.propTypes = {
  currentBrief: PropTypes.string.isRequired,
}

export default PhotographerBrief
